import React, { ReactNode } from "react";

import { Flex } from "@common/styles/reusable/Flex/Flex.styles";

import { BaseDialog, useBaseDialog } from "./BaseDialog";

interface Props {
  modal: ReturnType<typeof useBaseDialog>;
  onClick?: () => void;
  children: ReactNode;
}

export function MediaPreviewDialog({ modal, onClick, children }: Props) {
  return (
    <BaseDialog
      {...modal}
      noBackground
      fullHeight
      fitContent
      noPadding
    >
      <Flex
        $alignItems="center"
        $justifyContent="center"
        onClick={onClick}
      >
        {children}
      </Flex>
    </BaseDialog>
  );
}
